// actionTypes.js
export const FETCH_DOCUMENTS_REQUEST = "FETCH_DOCUMENTS_REQUEST";
export const FETCH_DOCUMENTS_SUCCESS = "FETCH_DOCUMENTS_SUCCESS";
export const FETCH_DOCUMENTS_FAILURE = "FETCH_DOCUMENTS_FAILURE";

export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILURE = "GET_USERS_FAILURE";

export const GET_DOCUMENT_DETAIL_REQUEST = "GET_DOCUMENT_DETAIL_REQUEST";
export const GET_DOCUMENT_DETAIL_SUCCESS = "GET_DOCUMENT_DETAIL_SUCCESS";
export const GET_DOCUMENT_DETAIL_FAILURE = "GET_DOCUMENT_DETAIL_FAILURE";

export const POST_WAREHOUSE_USER_REQUEST = "POST_WAREHOUSE_USER_REQUEST";
export const POST_WAREHOUSE_USER_SUCCESS = "POST_WAREHOUSE_USER_SUCCESS";
export const POST_WAREHOUSE_USER_FAILURE = "POST_WAREHOUSE_USER_FAILURE";

export const UPDATE_WAREHOUSE_USER_REQUEST = "UPDATE_WAREHOUSE_USER_REQUEST";
export const UPDATE_WAREHOUSE_USER_SUCCESS = "UPDATE_WAREHOUSE_USER_SUCCESS";
export const UPDATE_WAREHOUSE_USER_FAILURE = "UPDATE_WAREHOUSE_USER_FAILURE";

export const FETCH_AUCTION_REQUEST = "FETCH_AUCTION_REQUEST";
export const FETCH_AUCTION_SUCCESS = "FETCH_AUCTION_SUCCESS";
export const FETCH_AUCTION_FAILURE = "FETCH_AUCTION_FAILURE";

export const FETCH_STATE_REQUEST = "FETCH_STATE_REQUEST";
export const FETCH_STATE_SUCCESS = "FETCH_STATE_SUCCESS";
export const FETCH_STATE_FAILURE = "FETCH_STATE_FAILURE";

export const SEARCH_USERS_REQUEST = "SEARCH_USERS_REQUEST";
export const SEARCH_USERS_SUCCESS = "SEARCH_USERS_SUCCESS";
export const SEARCH_USERS_FAILURE = "SEARCH_USERS_FAILURE";

export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILURE = "GET_USER_FAILURE";

export const CREATE_WAREHOUSE_UNIT_REQUEST = "CREATE_WAREHOUSE_UNIT_REQUEST";
export const CREATE_WAREHOUSE_UNIT_SUCCESS = "CREATE_WAREHOUSE_UNIT_SUCCESS";
export const CREATE_WAREHOUSE_UNIT_FAILURE = "CREATE_WAREHOUSE_UNIT_FAILURE";

export const SEARCH_WAREHOUSE_UNITS_REQUEST = "SEARCH_WAREHOUSE_UNITS_REQUEST";
export const SEARCH_WAREHOUSE_UNITS_SUCCESS = "SEARCH_WAREHOUSE_UNITS_SUCCESS";
export const SEARCH_WAREHOUSE_UNITS_FAILURE = "SEARCH_WAREHOUSE_UNITS_FAILURE";

export const SEARCH_UNIT_REQUEST = "SEARCH_UNIT_REQUEST";
export const SEARCH_UNIT_SUCCESS = "SEARCH_UNIT_SUCCESS";
export const SEARCH_UNIT_FAILURE = "SEARCH_UNIT_FAILURE";

export const UPDATE_WAREHOUSE_UNIT_REQUEST = "UPDATE_WAREHOUSE_UNIT_REQUEST";
export const UPDATE_WAREHOUSE_UNIT_SUCCESS = "UPDATE_WAREHOUSE_UNIT_SUCCESS";
export const UPDATE_WAREHOUSE_UNIT_FAILURE = "UPDATE_WAREHOUSE_UNIT_FAILURE";

export const GET_UNIT_BY_ID_REQUEST = "GET_UNIT_BY_ID_REQUEST";
export const GET_UNIT_BY_ID_SUCCESS = "GET_UNIT_BY_ID_SUCCESS";
export const GET_UNIT_BY_ID_FAILURE = "GET_UNIT_BY_ID_FAILURE";

export const GET_ALL_UNIT_DOCUMENT_REQUEST = "GET_ALL_UNIT_DOCUMENT_REQUEST";
export const GET_ALL_UNIT_DOCUMENT_SUCCESS = "GET_ALL_UNIT_DOCUMENT_SUCCESS";
export const GET_ALL_UNIT_DOCUMENT_FAILURE = "GET_ALL_UNIT_DOCUMENT_FAILURE";

export const GET_WAREHOUSE_HISTORY_REQUEST = "GET_WAREHOUSE_HISTORY_REQUEST";
export const GET_WAREHOUSE_HISTORY_SUCCESS = "GET_WAREHOUSE_HISTORY_SUCCESS";
export const GET_WAREHOUSE_HISTORY_FAILURE = "GET_WAREHOUSE_HISTORY_FAILURE";

export const GET_UNIT_HISTORY_REQUEST = "GET_UNIT_HISTORY_REQUEST";
export const GET_UNIT_HISTORY_SUCCESS = "GET_UNIT_HISTORY_SUCCESS";
export const GET_UNIT_HISTORY_FAILURE = "GET_UNIT_HISTORY_FAILURE";

export const CREATE_EDIT_API_STATUS_WAREHOUSE =
  "CREATE_EDIT_API_STATUS_WAREHOUSE";

export const WAREHOUSE_LOADER = "WAREHOUSE_LOADER";
export const CREATE_WAREHOUSE_DISABLE = "CREATE_WAREHOUSE_DISABLE";
